module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('carousel-page', {
    attrs: {
      "type": 5
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "gqyjs"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v(_vm._s(_vm.introduceInfo[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v(_vm._s(_vm.introduceInfo[0].subTitle))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row flexJCenter",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "aboutCard mb-5"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduceInfo[0].content)
    }
  })])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "SbgWarp"
  }, [_c('div', {
    staticClass: "bgtextTitle"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', {
    staticClass: "fbgTextWarp"
  }, [_c('div', {
    class: _vm.cutFbgTextIndex == 0 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(0)
      }
    }
  }, [_vm._v("企业介绍")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 1 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(1)
      }
    }
  }, [_vm._v("愿景与服务")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 2 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(2)
      }
    }
  }, [_vm._v("我们能做什么")]), _vm._v(" "), _c('div', {
    class: _vm.cutFbgTextIndex == 3 ? "cutFbgTextItem" : "fbgTextItem",
    on: {
      "click": function($event) {
        return _vm.cutIndex(3)
      }
    }
  }, [_vm._v("联系我们")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "aboutCard mb-5"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/about/js.png",
      "alt": "企业介绍"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "yjyfw"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100vw",
      "z-index": "-100",
      "position": "absolute",
      "height": "580px"
    },
    attrs: {
      "src": "static/assets/images/about/bg.png",
      "alt": "愿景与服务"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("愿景与服务")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("VISION AND SERVICE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row flexJCenter"
  }, [_c('div', {
    staticClass: "col-lg-5 textCenter"
  }, [_c('div', {
    staticClass: "aboutCard mb-5"
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": "static/assets/images/about/yj.png",
      "alt": "愿景"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("愿景")]), _vm._v(" "), _c('h4', [_vm._v("VISION")]), _vm._v(" "), _c('p', [_vm._v("成为中国涉旅行业最优数字化服务商")]), _vm._v(" "), _c('p', [_vm._v("成为智慧涉旅行业首选品牌")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 textCenter"
  }, [_c('div', {
    staticClass: "aboutCard mb-5"
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": "static/assets/images/about/sm.png",
      "alt": "使命"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("使命")]), _vm._v(" "), _c('h4', [_vm._v("MISSION")]), _vm._v(" "), _c('p', [_vm._v("服务涉旅行业发展")]), _vm._v(" "), _c('p', [_vm._v("助力涉旅商家成功")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "wmnzsm"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("我们能做什么")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("WHAT CAN WE DO")]), _vm._v(" "), _c('p', [_vm._v("公司目前拥有数字化运营平台、营销云平台、分销云平台、数据指挥云平台、车辆监管平台、年卡运营平台、景区票务平台、政府监管平台等八大平台版块。依托于数字化平台为安阳市打造全域文旅智慧解决方案（安阳文旅公共服务中心），并集合本地资源推出相关产品线上数字化运营。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row flexJCenter"
  }, [_c('div', {
    staticClass: "col-lg-5 textCenter"
  }, [_c('div', {
    staticClass: "single-feature mb-5"
  }, [_c('h2', [_vm._v("6年")]), _vm._v(" "), _c('h4', [_vm._v("行业沉淀")]), _vm._v(" "), _c('p', {
    staticClass: "py-3"
  }, [_vm._v("\n              INDUSTRY PRECIPITATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 textCenter"
  }, [_c('div', {
    staticClass: "single-feature mb-5"
  }, [_c('h2', [_vm._v("7年")]), _vm._v(" "), _c('h4', [_vm._v("运营经验")]), _vm._v(" "), _c('p', {
    staticClass: "py-3"
  }, [_vm._v("\n              OPERATIONAL EXPERIENCE")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": "glxwm"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("CONTACT US")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/about/map.png",
      "alt": "联系我们"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a2f3a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 102
// module chunks = 1